/* 
 * TODO: if we want to have multiple owner logging in to default site,
 * we should fetch available owner ids from api
*/
export default {
  ownerID: 1
}
